import {Directive, ElementRef, HostListener, Input, OnChanges, OnDestroy, SimpleChanges} from '@angular/core';

@Directive({
    standalone: false,
    selector: '[appTooltip]'

})
export class ShowHideHoverDirective implements OnDestroy, OnChanges {
    @Input()
    className: string;

    constructor(private elementRef: ElementRef) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.className = '.' + changes.className.currentValue;
    }

    @HostListener('mouseenter')
    onMouseEnter(): void {
        this.elementRef.nativeElement.querySelector(this.className).style.display = 'block';
    }

    @HostListener('mouseleave')
    onMouseLeave(): void {
        this.destroy();
    }

    destroy(): void {
        this.elementRef.nativeElement.querySelector(this.className).style.display = 'none';
    }

    ngOnDestroy(): void {
        this.destroy();
    }


}
